import request from '@/utils/request'

/**
 * 获取供应链分类列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listChainSupplierCatalog(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainSupplierCatalog.listChainSupplierCatalog',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加供应链分类
 * @param {Object} data 分类数据
 * @returns {Promise} Promise对象
 */
export function saveChainSupplierCatalog(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainSupplierCatalog.saveChainSupplierCatalog',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新供应链分类
 * @param {Object} data 分类数据
 * @returns {Promise} Promise对象
 */
export function updateChainSupplierCatalog(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainSupplierCatalog.updateChainSupplierCatalog',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除供应链分类
 * @param {Object} data 分类数据
 * @returns {Promise} Promise对象
 */
export function deleteChainSupplierCatalog(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainSupplierCatalog.deleteChainSupplierCatalog',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export default {
  listChainSupplierCatalog,
  saveChainSupplierCatalog,
  updateChainSupplierCatalog,
  deleteChainSupplierCatalog
}